<template>
  <div>
    <page-loader v-if="loader" />
    <div
      v-else
      class="row"
    >
      <div class="col-20">
        <title-block
          :title="campaign.name"
        />
      </div>
      <div class="col-20">
        <status-bar
          :campaign="campaign"
          :is-advertiser="isAdvertiser"
          class="mt-2"
        />
        <campaign-info
          :campaign="campaign"
          :advertiser="advertiser"
          class="mt-3"
        />
        <report-advertiser
          v-if="isAdvertiser"
          :campaign="campaign"
          :report="report"
          class="mt-3"
        />
        <report-influencer
          v-else
          :campaign="campaign"
          class="mt-3"
        />
        <campaigns-cpc-members
          v-if="isAdvertiser"
          :campaign="campaign"
          :members="members"
          :report="report"
          class="mt-3"
        />
      </div>
    </div>
    <div class="row my-5">
      <div class="col-20 text-center">
        <std-button
          type="C"
          :title="$t('common.button.back')"
          :direction="'left'"
          add-class="mx-2 my-2"
          :route-link="{name: 'campaigns-cpc'}"
        />
        <span v-if="!loader && isAdvertiser">
          <std-button
            type="A"
            :title="$t('common.button.edit')"
            add-class="mx-2 my-2"
            :route-link="{ name: 'campaign-cpc-add-edit', params: { id: campaign.id } }"
          />
          <std-button
            v-if="campaign.status != 'canceled'"
            type="D"
            :title="$t('view-CampaignsCpc.Delete.button.end-campaign')"
            add-class="mx-2 my-2"
            :route-link="{ name: 'campaign-cpc-delete', params: { id: campaign.id } }"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './details/Info.vue'
import StatusBar from './details/StatusBar.vue'
import ReportAdvertiser from './details/Report.vue'
import ReportInfluencer from './details/ReportInfluencer.vue'
import Members from './details/Members.vue'

export default {
  components: {
    'campaign-info': Info,
    'status-bar': StatusBar,
    'report-advertiser': ReportAdvertiser,
    'report-influencer': ReportInfluencer,
    'campaigns-cpc-members': Members
  },
  data () {
    return {
      loader: true,
      campaignCpcId: 0
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    advertiser () {
      return this.$store.getters['advertisers/get'](this.campaign.advertiser_id)
    },
    campaign () {
      const campaignCpc = this.$store.getters[this.isAdvertiser ? 'campaignsCpcAdvertiser/getItem' : 'campaignsCpcInfluencer/getItem'](this.campaignCpcId)
      return campaignCpc || { name: '' }
    },
    report () {
      if (this.isAdvertiser) {
        return this.$store.getters['campaignsCpcAdvertiser/getReport'](this.campaignCpcId)
      }
      return null
    },
    members () {
      if (this.isAdvertiser) {
        return this.$store.getters['campaignsCpcAdvertiser/getMembers'](this.campaignCpcId)
      }
      return null
    }
  },
  created () {
    this.campaignCpcId = this.$route.params.id
    if (!this.campaignCpcId) {
      this.$router.push({ name: 'campaigns-cpc' })
    }
    const campaignLoad = new Promise((resolve, reject) => {
      this.$store.dispatch(this.isAdvertiser ? 'campaignsCpcAdvertiser/getOne' : 'campaignsCpcInfluencer/getOne', this.campaignCpcId)
        .then((result) => {
          if (this.$store.getters['advertisers/get'](result.advertiser_id)) {
            resolve()
          } else {
            this.$store.dispatch('advertisers/get', result.advertiser_id)
              .then(() => {
                resolve()
              })
              .catch(() => {
                this.$router.push({ name: 'campaigns-cpc' })
              })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'campaigns-cpc' })
        })
    })

    const reportLoad = new Promise((resolve, reject) => {
      if (this.isAdvertiser) {
        this.$store.dispatch('campaignsCpcAdvertiser/getReport', this.campaignCpcId)
          .then((result) => {
            resolve()
          })
          .catch((e) => {
            this.$router.push({ name: 'campaigns-cpc' })
          })
      } else {
        resolve()
      }
    })

    const membersLoad = new Promise((resolve, reject) => {
      if (this.isAdvertiser) {
        this.$store.dispatch('campaignsCpcAdvertiser/getMembers', this.campaignCpcId)
          .then((result) => {
            resolve()
          })
          .catch((e) => {
            this.$router.push({ name: 'campaigns-cpc' })
          })
      } else {
        resolve()
      }
    })

    Promise.all([
      campaignLoad,
      reportLoad,
      membersLoad
    ]).then((values) => {
      this.loader = false
    })
  }
}
</script>
